import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ScrollspyNav from './Scrollspy';
import styled from 'styled-components';

// Images
import logo from '../../images/Khyros_logo_design1.png';
import logoLight from '../../images/Khyros_logo_design1.png';

// Components
import ContactModal from '../../components/ContactModal';

// Styled Components for Modern Header
const ModernNav = styled.nav`
  background: rgba(10, 14, 39, 0.95) !important;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(81, 194, 201, 0.1);
  transition: all 0.3s ease;
  
  &.nav-sticky {
    background: rgba(10, 14, 39, 0.98) !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    border-bottom: 1px solid rgba(81, 194, 201, 0.2);
  }
  
  .navbar-brand {
    cursor: pointer;
    position: relative;
    z-index: 100;
    
    img {
      height: 35px;
      width: auto;
      max-width: none;
      transition: all 0.3s ease;
      object-fit: contain;
    }
    
    .logo-dark {
      display: none !important;
    }
    
    .logo-light {
      display: inline-block !important;
    }
    
    &:hover img {
      transform: scale(1.05);
    }
  }
  
  .navbar-nav {
    flex-wrap: nowrap;
    
    .nav-item {
      margin: 0 4px;
      
      @media (min-width: 1200px) {
        margin: 0 8px;
      }
      
      .nav-link {
        color: #cbd5e1 !important;
        font-weight: 500;
        font-size: 0.85rem;
        padding: 0.5rem 0.7rem !important;
        transition: all 0.3s ease;
        position: relative;
        white-space: nowrap;
        
        @media (min-width: 1200px) {
          font-size: 0.95rem;
          padding: 0.5rem 1rem !important;
        }
        
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #51c2c9, #2eb8bf);
          transform: translateX(-50%);
          transition: width 0.3s ease;
        }
        
        &:hover {
          color: #ffffff !important;
          
          &::after {
            width: 80%;
          }
        }
      }
      
      &.active .nav-link {
        color: #51c2c9 !important;
        
        &::after {
          width: 80%;
        }
      }
    }
  }
  
  .navbar-btn {
    background: linear-gradient(135deg, #51c2c9 0%, #2eb8bf 100%);
    color: #ffffff;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.8rem;
    transition: all 0.3s ease;
    margin-left: 0.5rem;
    white-space: nowrap;
    
    @media (min-width: 1200px) {
      padding: 0.6rem 1.5rem;
      font-size: 0.9rem;
      margin-left: 1rem;
    }
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 15px rgba(81, 194, 201, 0.4);
    }
  }
  
  .navbar-toggler {
    border-color: rgba(81, 194, 201, 0.3);
    
    i {
      color: #cbd5e1;
      font-size: 1.5rem;
    }
    
    &:focus {
      box-shadow: none;
    }
  }
`;

const NavItems = (props: {
    toggleModal: ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined;
    noScrollSpy: boolean;
}) => {
    const {toggleModal, noScrollSpy} = props;
    return (
        <>
            <ul className="navbar-nav ml-auto navbar-center" id="mySidenav">
                <li className={`nav-item ${noScrollSpy ? '' : 'active'}`}>
                    <a href="/#home" className="nav-link">Home</a>
                </li>
                <li className="nav-item">
                    <a href="/#about" className="nav-link">About</a>
                </li>
                <li className="nav-item">
                    <a href="/#features" className="nav-link">Features</a>
                </li>
                <li className="nav-item">
                    <a href="/#services" className="nav-link">Applications</a>
                </li>
                <li className="nav-item">
                    <a href="https://app.khyros.ai/" className="nav-link" target="_blank" rel="noopener noreferrer">Platform</a>
                </li>
                <li className="nav-item">
                    <Link onClick={toggleModal} to="#" className="nav-link">Contact</Link>
                </li>
            </ul>
            <button onClick={toggleModal} className="btn btn-sm navbar-btn">Free Trial</button>
        </>
    );
}
interface HeaderMultiProps {
    noScrollSpy?: boolean;
    light?: boolean;
}
class HeaderMulti extends Component<HeaderMultiProps,{
    Tab: string;
    isOpen: boolean;
    modal: boolean;
    isOpenMenu: boolean;
}> {

    constructor(props: HeaderMultiProps) {
        super(props);
        this.state = { 
            Tab: '', 
            isOpen: false, 
            modal: false,
            isOpenMenu: false 
        };

        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleHeader = this.toggleHeader.bind(this);
    }
    toggleHeader = () => {
        this.setState({ isOpenMenu: !this.state.isOpenMenu });
    }
    toggleModal() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    toggleMenu = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    render() {
        const {light} = this.props;
        const noScrollSpy = this.props.noScrollSpy || false;
        
        return (
            <React.Fragment>
                <ContactModal show={this.state.modal} onHide={this.toggleModal} />

                <div id="is-sticky">
                    <ModernNav id="nav-bar" className={`navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark ${light ? 'nav-sticky' : ''}`}>
                        <div className="container">
                            <a 
                                href="/" 
                                className="navbar-brand logo text-uppercase"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.location.href = '/';
                                }}
                            >
                                <img src={logoLight} alt="Khyros Logo" className="logo-light" />
                                <img src={logo} alt="Khyros Logo" className="logo-dark" />
                            </a>

                            <button className="navbar-toggler" type="button" onClick={this.toggleHeader}>
                                <i className="mdi mdi-menu"></i>
                            </button>
                            
                            <div className={this.state.isOpenMenu ? "collapse navbar-collapse show" : "collapse navbar-collapse"} id="navbarCollapse">
                                {
                                    noScrollSpy ? (
                                        <NavItems noScrollSpy={noScrollSpy} toggleModal={this.toggleModal}/>
                                    ) : (
                                        <ScrollspyNav
                                            scrollTargetIds={["home", "about", "features", "services"]}
                                            activeNavClass="active"
                                            scrollDuration="800"
                                            headerBackground="true"
                                            className={this.state.isOpenMenu ? "navbar-nav ml-0 float-left" : "navbar-nav ml-auto navbar-center"}>
                                            <NavItems noScrollSpy={noScrollSpy} toggleModal={this.toggleModal}/>
                                        </ScrollspyNav>
                                    )
                                }
                            </div>
                        </div>
                    </ModernNav>
                </div>
            </React.Fragment>
        );
    }
}

export default HeaderMulti;
